import * as React from "react";
import { Badge } from "@ui/core";
import { useTranslation } from "react-i18next";

export default function Forbidden() {
  const { t: tUi } = useTranslation("ui");

  return (
    <div className="mx-auto max-w-lg rounded-md border border-warning/50 bg-warning/10 p-4 text-warning-foreground shadow-sm">
      <div className="flex items-center gap-2">
        <Badge variant="warning">403</Badge>
        <h2 className="text-lg font-semibold">
          {tUi("forbidden", { defaultValue: "Forbidden" })}
        </h2>
      </div>
      <p className="mt-2 text-sm text-muted-foreground">
        {tUi("youDonTHavePermissionToAccessThis", {
          defaultValue: "You don't have permission to access this resource.",
        })}
      </p>
    </div>
  );
}
